<template>
    <div>
        <label>
            {{ label }}
        </label>
        <b-form-input-date-between
            :start="{
                name: campo_1,
                value: filtro[campo_1]
            }"
            :end="{
                name: campo_2,
                value: filtro[campo_2]
            }"
            :disabled="desabilitado"
            :required="required"
            :class="[{ error: errors.first('buscaAvancada.periodo') }]"
            scope="filtro"
            @start="atualizaDataInicio($event)"
            @end="atualizaDataFim($event)"
        />
    </div>
</template>
<script>
export default {
    inject: ['$validator'],
    props: {
        label: {
            default: 'Período'
        },
        filtro: {
            default: null
        },
        campo: {
            default: null
        },
        desabilitado: {
            default: false
        },
        required: {
            default: false
        }
    },
    data() {
        return {
            campo_1: 'data_inicio',
            campo_2: 'data_fim'
        }
    },
    mounted () {

        if(this.campo){
            this.campo_1 = this.campo[0];
            this.campo_2 = this.campo[1];
        }

        if(this.$route.query[this.campo_1]){
            this.filtro[this.campo_1] = this.$route.query[this.campo_1];
        }

        if(this.$route.query[this.campo_2]){
            this.filtro[this.campo_2] = this.$route.query[this.campo_2];
        }       
        
    },
    methods: {
        atualizaDataInicio(data){
            this.filtro[this.campo_1] = data
            this.$emit('dataAlterada')
        },
        atualizaDataFim(data){
            this.filtro[this.campo_2] = data
            this.$emit('dataAlterada')
        },
    },
}
</script>
<style scoped>
.input-group {
    flex-wrap: unset;
}
::v-deep .input-group-date {
    min-width: auto !important;
}
</style>